/* Native swipe gallery; no autoplay or duplicate comparison images. */
(() => {
  const section = document.getElementById('results');
  if (!section) return;
  const track = section.querySelector('.mv-ba-grid');
  const cards = [...track.querySelectorAll('figure')];
  const nav = section.querySelector('.mv-results-nav');
  if (!nav || cards.length < 2) return;
  const previous = nav.querySelector('[data-results-prev]');
  const next = nav.querySelector('[data-results-next]');
  const count = nav.querySelector('[data-results-current]');
  const narrow = matchMedia('(max-width:899px)');
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  let current = 0;
  let queued = false;

  function sync() {
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    const firstLeft = cards[0].offsetLeft;
    current = atEnd ? cards.length - 1 : cards.reduce((closest, card, index) =>
      Math.abs(card.offsetLeft - firstLeft - track.scrollLeft) <
      Math.abs(cards[closest].offsetLeft - firstLeft - track.scrollLeft) ? index : closest, 0);
    count.textContent = String(current + 1).padStart(2, '0');
    previous.disabled = current === 0;
    next.disabled = current === cards.length - 1;
  }
  function goTo(index) {
    const target = Math.max(0, Math.min(index, cards.length - 1));
    track.scrollTo({left:cards[target].offsetLeft - cards[0].offsetLeft,
      behavior:reduced.matches ? 'auto' : 'smooth'});
  }
  function resize() {
    nav.hidden = !narrow.matches;
    if (narrow.matches) track.setAttribute('tabindex', '0');
    else track.removeAttribute('tabindex');
    sync();
  }
  previous.addEventListener('click', () => goTo(current - 1));
  next.addEventListener('click', () => goTo(current + 1));
  track.addEventListener('keydown', event => {
    if (!narrow.matches || event.target !== track) return;
    const targets = {ArrowLeft:current - 1, ArrowRight:current + 1, Home:0, End:cards.length - 1};
    if (!(event.key in targets)) return;
    event.preventDefault();
    goTo(targets[event.key]);
  });
  track.addEventListener('scroll', () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; sync(); });
  }, {passive:true});
  new ResizeObserver(resize).observe(track);
  narrow.addEventListener('change', resize);
  resize();
})();
